/* src/modules/tutors/cards/ViewDocumentsCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import {
  AppBar,
  Card,
  Modal,
  IconButton,
  Toolbar,
  Typography,
} from '@material-ui/core';

import { KeyboardArrowRight, KeyboardArrowLeft } from '@material-ui/icons';
import styles from './styles';

import { getTranscript } from '../../../../config/images';

class ViewDocumentsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      open: false,
      image: '',
      tutorID: '',
    };

    this._onNext = this._onNext.bind(this);
    this._onPrevious = this._onPrevious.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { open, tutorID } = nextProps;
    if (open && tutorID !== '') {
      // TODO: get page 0 here.
      getTranscript(tutorID, 0)
        .then(res => {
          this.setState({
            open,
            page: 0,
            image: res.data,
            tutorID,
          });
        })
        .catch(() => {
          this.setState({
            open,
            page: 0,
            image: '',
            tutorID,
          });
        });
    } else {
      this.setState({ open, page: 0 });
    }
  }

  _onNext() {
    const { tutorID, page } = this.state;
    const nextPage = page + 1;
    getTranscript(tutorID, nextPage)
      .then(res => {
        this.setState({ page: nextPage, image: res.data });
      });
  }

  _onPrevious() {
    const { tutorID, page } = this.state;
    const previousPage = page - 1;
    if (previousPage < 0) return;
    getTranscript(tutorID, previousPage)
      .then(res => {
        this.setState({ page: previousPage, image: res.data });
      });
  }

  render() {
    const { onClose, classes } = this.props;
    const { open, image, page } = this.state;
    return (
      <Modal
        aria-labelledby="View Documents"
        aria-describedby="View documents that tutor's uploaded"
        open={open}
        onClose={onClose}
      >
        <Card className={classes.card}>
          <AppBar position="static">
            <Toolbar>
              <Typography variant="title" color="inherit">
                {`Documents - page ${page + 1}`}
              </Typography>
            </Toolbar>
          </AppBar>
          <Typography className={classes.message}>
            {'Documents for this tutor may not exist if nothing appears below.'}
          </Typography>
          <div className={classes.content}>
            <div className={classes.buttonContainer}>
              <IconButton onClick={this._onPrevious}>
                <KeyboardArrowLeft />
              </IconButton>
            </div>
            {image !== '' && (
              <img src={image} alt={`document-${page}`} className={classes.image} />
            )}
            {image === '' && ( // TODO: add xml parser for link.
              <div className={classes.blank}>
                <Typography>
                  {'Documents for this tutor does not exist.'}
                </Typography>
              </div>
            )}
            <div className={classes.buttonContainer}>
              <IconButton onClick={this._onNext}>
                <KeyboardArrowRight />
              </IconButton>
            </div>
          </div>
        </Card>
      </Modal>
    );
  }
}

ViewDocumentsCard.propTypes = {
  onClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  tutorID: PropTypes.string.isRequired,
};

export default withStyles(styles)(ViewDocumentsCard);



// WEBPACK FOOTER //
// ./src/modules/tutors/cards/ViewDocumentsCard/index.js